/**
 * ObjectLabelField React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import TextField from '@material-ui/core/TextField';

// application
import {completeLabel} from "../../operations/editing";


/**
 * ObjectLabelField is an editing component for label fields of objects
 *
 * @author Jens Gruschel
 */
export class ObjectLabelField extends React.Component {

    render() {

        const { classes, fieldDef } = this.props;

        const value = this.props.completeLabel(this.props.objectId, fieldDef.value);

        // TODO: only code style supported right now

        const inputProps = {
            style: {
                fontFamily: "monospace,monospace"
            }
        };

        return (
            <TextField
                id={fieldDef.id}
                label={fieldDef.name}
                value={value}
                className={classes.codeField}
                InputProps={inputProps}
                margin="normal"
                multiline={true}
                fullWidth={true}
                type="text"
                helperText={fieldDef.note}
                variant="outlined"
            />
        );
    }
}

ObjectLabelField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    codeField: {
        marginTop: 16
    }
};

export default connect(null, {completeLabel})(withStyles(styles)(ObjectLabelField));